import {StickyEvent} from "const/StickyEvent"
import Logger from "logger/logger"
import {useEffect} from "react"

interface CustomEventMap {
  [StickyEvent.selectOpen]: CustomEvent<SelectOpenEvent>
  [StickyEvent.dropdownOpen]: CustomEvent<DropdownOpenEvent>
  [StickyEvent.widgetTitleClick]: CustomEvent<null>
  [StickyEvent.modalOverlayClick]: CustomEvent<null>
}

declare global {
  interface Document {
    addEventListener<K extends keyof CustomEventMap>(type: K, listener: (this: Document, ev: CustomEventMap[K]) => void): void;
  }
}

function EventService(caller: string) {

  useEffect(() => {
    Logger(`Service.Event.init.${caller}`)
    return () => {
      Logger(`Service.Event.unloading.${caller}`)
    }
  }, [])

  function subscribeEvent(eventName: string, listener: any) {
    document.addEventListener(eventName, listener)
  }

  function unsubscribeEvent(eventName: string, listener: any) {
    document.removeEventListener(eventName, listener)
  }

  function publishEvent<T extends keyof CustomEventMap>(eventName: string, data: CustomEventMap[T]['detail']) {
    const event = new CustomEvent(eventName, {detail: data})
    Logger(`Service.Event.publishEvent.${caller}`, eventName, event)
    document.dispatchEvent(event)
  }

  return {
    subscribeEvent,
    unsubscribeEvent,
    publishEvent,
  }
}

export default EventService


export type SelectOpenEvent = {
  isOpen: boolean
}

export type DropdownOpenEvent = {
  isOpen: boolean
}
